export const FETCHING_RAFFLE = '@app/raffleForm/fetchingRaffle';
export const FETCHED_RAFFLE = '@app/raffleForm/fetchedRaffle';
export const CLEAR_FETCHED_RAFFLE = '@app/raffleForm/clearFetchedRaffle';
export const FETCHING_CONSENTS = '@app/raffleForm/fetchingConsentsAction';
export const FETCHED_CONSENTS = '@app/raffleForm/fetchedConsentsAction';
export const FETCHING_COUNTRIES = '@app/raffleForm/fetchingCountriesAction';
export const FETCHED_COUNTRIES = '@app/raffleForm/fetchedCountriesAction';
export const FETCHING_ROMANIA_COUNTIES_AND_CITIES = '@app/raffleForm/fetchingRomaniaCountiesAndCitiesAction';
export const FETCHED_ROMANIA_COUNTIES_AND_CITIES = '@app/raffleForm/fetchedRomaniaCountiesAndCitiesAction';
export const UPDATE_ROMANIAN_CITY_OPTIONS = '@app/raffleForm/updateRomanianCityOptionsAction';
export const UPDATE_ADDRESS_COMPONENTS = '@app/raffleForm/updateAddressComponentsAction';

export const fetchingRaffleAction = () => ({
	type: FETCHING_RAFFLE
});

/**
 * @param {Raffle} raffle
 * @return {{type: string, raffle: Raffle}}
 */
export const fetchedRaffleAction = (raffle) => ({
	type: FETCHED_RAFFLE,
	raffle
});

export const fetchingConsentsAction = () => ({
	type: FETCHING_CONSENTS
});

/**
 * @param {ConsentData[]} consents
 * @return {{type: string, consents: ConsentData[]}}
 */
export const fetchedConsentsAction = (consents) => ({
	type: FETCHED_CONSENTS,
	consents
});

export const fetchingCountriesAction = () => ({
	type: FETCHING_COUNTRIES
});

/**
 * @param {SelectOption[]} countries
 * @param {SelectOption[]} usStates
 * @param {SelectOption[]} caStates
 * @return {{type: string, countries: SelectOption[]}}
 */
export const fetchedCountriesAction = (countries, usStates, caStates) => ({
	type: FETCHED_COUNTRIES,
	countries,
	usStates,
	caStates
});

export const fetchingRomaniaCountiesAndCitiesAction = () => ({
	type: FETCHING_ROMANIA_COUNTIES_AND_CITIES
});

/**
 * @param {Object} romanianCountiesAndCities
 * @return {{type: string, romanianCountiesAndCities: Object}}
 */
export const fetchedRomaniaCountiesAndCitiesAction = (romanianCountiesAndCities) => ({
	type: FETCHED_ROMANIA_COUNTIES_AND_CITIES,
	romanianCountiesAndCities
});

export const updateRomanianCityOptionsAction = () => ({
	type: UPDATE_ROMANIAN_CITY_OPTIONS
});

export const updateAddressComponentsAction = (fields) => ({
	type: UPDATE_ADDRESS_COMPONENTS,
	fields
});

export const clearFetchedRaffleAction = () => ({
	type: CLEAR_FETCHED_RAFFLE
});



// WEBPACK FOOTER //
// ./actions/RaffleFormActions.js